import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {loadImage} from '../image-inline-editor/loadImage';

const scriptjs: any = require('scriptjs');

export interface AviaryPremiumPartnerAuthData {
    salt: string;
    timestamp: string;
    signature: string;
    encryptionMethod: string;
}

export interface AviaryResultHandle {
    getImageData(): Promise<string>;
    getIsDirty(): boolean;
    getActionList(): any;
}

export interface AvairyEditorProps extends React.Props<AviaryEditor> {
    imageUrl: string;
    apiKey: string;
    resultFileFormat: 'jpg' | 'png';
    premiumPartnerAuthData?: AviaryPremiumPartnerAuthData;
    aviaryConfigOverride?: any;
    aviaryTranslationsOverride?: any;
    onResultHandle(resultHandle: AviaryResultHandle): void;
}

export const DefaultAviaryTools = [
    "crop",
    "orientation",
    "lighting",
    "sharpness",
    "text",
    "effects",
    "frames",
    "color",
    "focus",
    "blemish"
];

declare var Aviary: any; // TODO d.ts

export default class AviaryEditor extends React.Component<AvairyEditorProps, {}> {
    private featherEditor: any;

    componentDidMount() {
        if (typeof Aviary === 'undefined') {
            scriptjs('https://dme0ih8comzn4.cloudfront.net/imaging/v3/editor.js', this.createAviary);
        } else {
            this.createAviary();
            this.launchAviary();
        }
    }

    componentDidUpdate(prevProps: AvairyEditorProps) {
        if (prevProps.imageUrl !== this.props.imageUrl) {
            this.featherEditor.close();
            this.launchAviary();
        }
    }

    componentWillUnmount() {
        this.featherEditor.close();
    }

    render() {
        return <div style={this.getStyles().root} id="aviary_container"></div>;
    }

    private createAviary = () => {
        // some translations should be present before Aviary is initialize e.g.
        if (!Aviary.languageStrings) {
            Aviary.languageStrings = this.props.aviaryTranslationsOverride;
        }

        const auth = this.props.premiumPartnerAuthData;
        this.featherEditor = new Aviary.Feather(Object.assign({},
            // default values for overridable configs
            {
                tools: DefaultAviaryTools,
                maxSize: 10000
            },
            this.props.aviaryConfigOverride,
            auth || {},
            {
                isPremiumPartner: !!auth,
                apiKey: this.props.apiKey,
                fileFormat: this.props.resultFileFormat,
                launchDelay: 0,
                closeDelay: 0,
                apiVersion: 3,
                theme: 'minimum',
                noCloseButton: true,
                appendTo: ReactDOM.findDOMNode(this),
                onLoad: this.onAviaryLoad,
                onError: this.onAviaryError,
                onReady: this.onAviaryReady,
                language: this.getLanguage()
            }
        ));
    };

    private onAviaryError = (errorObj: any) => {
        throw new Error("Failed to load aviary:: " + errorObj.message);
    };

    private onAviaryLoad = () => {
        if (this.props.aviaryTranslationsOverride && Aviary.languageStrings ) {
            // overwrite translations
            Aviary.languageStrings = Object.assign({}, Aviary.languageStrings, this.props.aviaryTranslationsOverride);
        }
        this.launchAviary();
    };

    private launchAviary = () => {
        loadImage(this.props.imageUrl).then((image) => {
            // create id for dummy image element in DOM for use by Aviary
            const id = 'aviary-temporary-placeholder';
            const old = document.getElementById(id);
            if (old) {
                document.body.removeChild(old);
            }
            image.id = id;
            image.style.display = 'none';
            document.body.appendChild(image);
            this.featherEditor.launch({image: image.id});
            this.props.onResultHandle({
                getImageData: () => {
                    return new Promise((resolve, reject) => {
                        this.featherEditor.getImageData((base64ImageUrl: string) => {
                            resolve(base64ImageUrl);
                        });
                    });
                },
                getIsDirty: () => {
                    // TODO Aviry returns false here even if there are changes -> report a bug
                    // return this.featherEditor.getIsDirty();

                    // XXX using actions JSON to detect dirty state
                    try {
                        const actions = JSON.parse(this.featherEditor.getActionList());
                        return actions.actions.length > 0;
                    } catch (e) {
                        return true; // by default consider it dirty
                    }
                },
                getActionList: () => {
                    return this.featherEditor.getActionList();
                }
            });
        });
    };

    private onAviaryReady = () => {
        // TODO migrate from current implementation
        this.fixTouchZoomBug();
        // TODO implement here disableIE11MouseCursorTextSelection from aviary.js
        // but make sure it is working on IE11 at all
    };

    private getLanguage() {
        if (this.props.aviaryConfigOverride) {
            return this.props.aviaryConfigOverride.language || 'en';
        }
        return 'en';
    }

    //bugfix: DHDIYED-692
    private fixTouchZoomBug() {
        const rootEl = ReactDOM.findDOMNode(this);
        const zoomBtn = rootEl.querySelector('#avpw_zoom_button');
        if (zoomBtn) {
            zoomBtn.addEventListener('touchstart', function() {
                const container = rootEl.querySelector('#avpw_zoom_container');
                if (container) {
                    container.classList.toggle('avpw_zoom_open');
                }
            });
        }
    };

    private getStyles() {
        return {
            root: {
                height: 400
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/aviary/AviaryEditor.tsx
 **/